export enum EHubContext {
    IS_VIEWER_ONLY = 'isViewerOnly'
}
